import React, { useEffect, useState } from 'react';
import Input from '../components/input';
import Button from '../components/button';
import { useAuthContext } from '../context/Auth';
import moment from 'moment';
import api from '../utils/api';
import { isMobile } from 'react-device-detect';
import { getProfileLabel } from '../utils/profileLabel';

const Account = () => {

  const { userInfos } = useAuthContext();
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingChangePassword, setIsLoadingChangePassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  useEffect(() => {
    if (userInfos?.name) {
      setIsLoading(false);
    }
  }, [userInfos]);

  // Função para lidar com a mudança de senhas
  const handleChangePassword = (e) => {

    if(newPassword != confirmPassword){
      alert('As senhas não conferem');
      return;
    }

    setIsLoadingChangePassword(true);
    
    api.patch('/auth/password', {
      current_password: currentPassword,
      new_password: newPassword,
    }, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then(res => {
        
      setIsLoadingChangePassword(false);
      alert("Atualizado com sucesso!");

    })
    .catch(err => {
      setIsLoadingChangePassword(false);
      alert("Erro ao atualizar");
    })

  };

  return (
    <>
      {/* Dados da Conta */}
      <div className="bg-white p-6 rounded-lg shadow-lg mb-6">
        <h2 className="text-base font-semibold mb-4">Informações da Conta</h2>
        {isLoading ? (
          <div className="space-y-4">
            <div className="h-4 bg-gray-200 rounded w-3/4 animate-pulse"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2 animate-pulse"></div>
            <div className="h-4 bg-gray-200 rounded w-2/3 animate-pulse"></div>
          </div>
        ) : (
          <>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">Nome:</label>
              <p className="text-gray-800">{userInfos?.name}</p>
            </div>
            
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">E-mail:</label>
              <p className="text-gray-800">{userInfos?.email}</p>
            </div>

            {userInfos?.cnpj && (
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">CNPJ da Empresa:</label>
                <p className="text-gray-800">{userInfos?.cnpj}</p>
              </div>
            )}

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">Tipo de Perfil:</label>
              <p className="text-gray-800">{getProfileLabel(userInfos?.profile)}</p>
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">Data de Cadastro:</label>
              <p className="text-gray-800">{userInfos?.created_at && moment(userInfos?.created_at).format('DD/MM/YYYY')}</p>
            </div>
          </>
        )}
      </div>

      {(!isLoading && userInfos?.tax) && (
        <>
          {/* Informações financeiras da Conta */}
          <div className="bg-white p-6 rounded-lg shadow-lg mb-6">
            <h2 className="text-base font-semibold mb-4">Informações financeiras da Conta</h2>
            {isLoading ? (
              <div className="space-y-4">
                <div className="h-4 bg-gray-200 rounded w-3/4 animate-pulse"></div>
              </div>
            ) : (
              <>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">Taxa de cobrança de boletos:</label>
                  <p className="text-gray-800">{userInfos?.tax}%</p>
                </div>
              </>
            )}
          </div>
        </>
      )}

      {/* Formulário de Alteração de Senha */}
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-base font-semibold mb-4">Alterar Senha</h2>
        
        <div className="mb-4">
          <Input
              fullWidth
              label="Senha atual"
              type="password"
              id="currentPassword"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
          />
        </div>

        <div className="mb-4">
          <Input
              fullWidth
              label="Nova senha:"
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
          />
        </div>

        <div className="mb-4">
          <Input
              fullWidth
              label="Confirmar Nova Senha:"
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
          />
        </div>

        <div className="flex justify-end">
          <Button 
            disabled={!currentPassword || !newPassword || !confirmPassword}
            isLoading={isLoadingChangePassword}
            onClick={handleChangePassword}
            size="large"
            fullWidth={isMobile}
          >
            Alterar senha
          </Button>
        </div>

      </div>
    </>
  );
};

export default Account;
